import React from 'react'
import './my-events-page.css'

function MyEventsPage() {
  return (
    <div>MyEventsPage</div>
  )
}

export default MyEventsPage